<template>
  <div>
    <div class="locations-ct">
      <!-- Notification trigger section -->
      <notification-trigger :model="model" />

      <!-- Add locations section -->
      <add-locations :model="model" />

      <!-- Trigger limits section -->
      <trigger-limits :model="model" />
    </div>
    <div class="footer">
      <div class="footer-ct">
        <el-button type="primary" @click="nextStep" data-qa="next-step-btn">
          {{ $t('CampaignForm_Locations_NextButton_Title') }}
          <i class="el-icon-arrow-right el-icon-right"></i>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import AddLocations from '@/modules/campaign-manage/components/locations/AddLocations'
import NotificationTrigger from '@/modules/campaign-manage/components/locations/NotificationTrigger'
import TriggerLimits from '@/modules/campaign-manage/components/locations/TriggerLimits'
import { EventBus } from '@/core/EventBus'
export default {
  name: 'StepLocations',

  components: { AddLocations, NotificationTrigger, TriggerLimits },

  props: {
    model: {
      type: Object
    }
  },

  methods: {
    nextStep() {
      EventBus.$emit('campaign-create-next-step')
    }
  }
}
</script>

<style scoped>
.locations-ct {
  padding-bottom: 60px;
}
.footer {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 60px;
  background: #ffffff;
  z-index: 1;
  border-top: 1px solid #e5e5e5;
}
.footer-ct {
  margin-right: 20px;
  margin-bottom: 12px;
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/pages/StepLocations.vue